export function PageHeader({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={`my-7 flex items-center justify-between gap-4 ${className}`}>{children}</div>;
}
